export enum ChatMessageType {
  JOIN_CHAT = 'join_chat',
  LEAVE_CHAT = 'leave_chat',
  MESSAGE = 'message',
}
